<template>
  <v-card title="发票推送日志">
    <div class="grid-demo">
      <v-more-panel>
        <v-form slot="form">
          <v-form-item label="发送时间">
            <v-date-picker v-model="options.fssjq"></v-date-picker>
            -
            <v-date-picker v-model="options.fssjz"></v-date-picker>
          </v-form-item>
          <v-form-item label="状态"
            ><v-select
              style="width: 100px"
              v-model="options.zt"
              :data="zt_options"
            ></v-select
          ></v-form-item>
          <v-form-item label="业务单号">
            <v-input placeholder="" v-model="options.ywdh"></v-input>
          </v-form-item>
          <v-form-item label="UID">
            <v-input placeholder="" v-model="options.uid"></v-input>
          </v-form-item>
        </v-form>
        <v-form-item>
          <v-button type="primary" icon="search" @click="findList()"
            ><span>查询</span></v-button
          >
        </v-form-item>
      </v-more-panel>
    </div>
    <br />
    <vxe-grid v-bind="xGridOptions" size="mini" ref="xTable" :data="tableData">
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
    <vxe-pager
      :current-page="pagination.pageindex"
      :page-size="pagination.pagesize"
      :total="pagination.totalresult"
      :layouts="[
        'PrevPage',
        'JumpNumber',
        'NextPage',
        'FullJump',
        'Sizes',
        'Total',
      ]"
      @page-change="handlePageChange"
    ></vxe-pager>
  </v-card>
</template>
<script>
let options = {
  fssjq: "",
  fssjz: "",
  zt: "2",
  ywdh: "",
  uid:""
};
let pagination = {
  sort: "fssj",
  sorttype: "desc",
  pagesize: 10,
  pageindex: 1,
  totalresult: 1,
};
let zt_options = [
  { value: "1", label: "成功" },
  { value: "2", label: "失败" },
];
export default {
  data() {
    return {
      pagination,
      options,
      zt_options,
      tableData: [],
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        loading:false,
        height: 450,
        headerAlign: "center",
        columns: [
          {
            field: "rn",
            title: "序号",
            align: "center",
            sortable: true,
          },
          {
            field: "ywdh",
            title: "业务单号",
            align: "center",
            sortable: true,
          },
          {
            field: "uid",
            title: "用户id",
            align: "center",
            sortable: true,
          },
          {
            field: "lsh",
            title: "申请流水号",
            align: "center",
            sortable: true,
          },
          {
            field: "yxdz",
            title: "接收方邮箱",
            align: "center",
            sortable: true,
          },
          {
            field: "fpdm",
            title: "发票代码",
            align: "center",
            sortable: true,
          },
          {
            field: "fphm",
            title: "发票号码",
            align: "center",
            sortable: true,
          },
          {
            field: "je",
            title: "金额",
            headerAlign: "center",
            align: "right",
            formatter: "formatNumber",
            sortable: true,
          },
          {
            field: "zt",
            title: "状态",
            align: "center",
            sortable: true,
            slots: {
              default: ({ row, column }) => {
                let zt = "";
                if (row.zt == "1") {
                  zt = "成功";
                } else {
                  zt = "失败";
                }
                return [<span>{zt}</span>];
              },
            },
          },
          {
            field: "yy",
            title: "失败原因",
            align: "center",
            sortable: true,
          }
        ],
      },
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.xGridOptions.loading=true
      this.$axios
        .get(
          "api/system/logcx/get-fslog-list?cx=" +
            JSON.stringify(this.options),
          {
            params: this.pagination,
          }
        )
        .then((res) => {
          this.tableData = res.data.data;
          this.pagination.totalresult = res.data.total;
          this.xGridOptions.loading=false
        });
    },
    handlePageChange({ currentPage, pageSize }) {
      this.pagination.pageindex = currentPage;
      this.pagination.pagesize = pageSize;
      this.findList();
    },
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/ywgl/fslog.vue